module.exports = __webpack_public_path__ + "media/images/ico-0b5acce1867804f31933961daa1b88a6.jpeg";